import * as React from 'react';

import { NavigationSectionRouteData, NavigationRouteData, UseNavigationSectionedRoutesHook } from '@tdp/common/detailsNavigation';

import { NavItem, NavMenu } from '../NavMenu';
import { NavSection } from './NavSection';

export interface ICreateSectionedNavMenuOptions<TData extends object = object> {
  hook: UseNavigationSectionedRoutesHook<TData>;
  renderSection: (section: NavigationSectionRouteData<TData>) => React.ReactNode;
  renderNavItem: (item: NavigationRouteData<TData>) => React.ReactNode;
}

/*
 * Utility function for creating a 'Nav Menu' component for a specific data object type.
 */
export function createSectionedNavMenu<TData>(options: ICreateSectionedNavMenuOptions<TData>) {
  return function NavigationMenu({ className }: { className?: string }) {
    const { hook: useNavData, renderSection, renderNavItem } = options;
    const navData = useNavData();

    function NavigationMenuSection(section: NavigationSectionRouteData<TData>) {
      const [isOpen, setIsOpen] = React.useState(true);
      return (
        <NavSection key={section.id} title={renderSection(section)} collapsed={!isOpen} active={section.isActive} onToggle={() => { setIsOpen(!isOpen); }}>
          {section.routes.map(route =>
            <NavItem key={route.path} href={route.path} active={route.isActive}>
              {renderNavItem(route)}
            </NavItem>
          )}
        </NavSection>
      );
    }

    return (
      <NavMenu className={className}>
        {navData.map(section => <NavigationMenuSection key={section.id} {...section} />)}
      </NavMenu>
    )
  }
}
